import { render, staticRenderFns } from "./MdNewsList.vue?vue&type=template&id=1380affc&scoped=true&"
import script from "./MdNewsList.vue?vue&type=script&lang=js&"
export * from "./MdNewsList.vue?vue&type=script&lang=js&"
import style0 from "./MdNewsList.vue?vue&type=style&index=0&id=1380affc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380affc",
  null
  
)

export default component.exports